import { render, staticRenderFns } from "./repeatAnalysis.vue?vue&type=template&id=6c32a84a&scoped=true"
import script from "./repeatAnalysis.vue?vue&type=script&lang=js"
export * from "./repeatAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c32a84a",
  null
  
)

export default component.exports